export class ProgramProjectMismatchMessage {
    public programName: string;
    public projectName: string;
    
    constructor(programName : string, projectName: string)
    {
        this.programName = programName;
        this.projectName = projectName;
    }
}